import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Builds the footer message after an invalid save, for example 'Fix 2 fields before you save.'.
 * The function counts only the enabled fields that are invalid.
 */
export function buildValidationMessage(form: FormGroup): string {
  const count = countInvalidFields(form);

  return count === 1 ? 'Fix 1 field before you save.' : `Fix ${count} fields before you save.`;
}

function countInvalidFields(control: AbstractControl): number {
  if (control instanceof FormGroup) {
    return Object.values(control.controls).reduce((total, child) => total + countInvalidFields(child), 0);
  }

  return control.enabled && control.invalid ? 1 : 0;
}
